import { render, staticRenderFns } from "./SalesRanking.vue?vue&type=template&id=2a2151dd&scoped=true"
import script from "./SalesRanking.vue?vue&type=script&lang=js"
export * from "./SalesRanking.vue?vue&type=script&lang=js"
import style0 from "./SalesRanking.vue?vue&type=style&index=0&id=2a2151dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2151dd",
  null
  
)

export default component.exports